/**
 * Created by codingnuts on 2017/12/27.
 */

export const ACTION_LOGIN = 'toLogin'; // 登陆
export const ACTION_LOGIN_NEW = 'toLoginNew'; // 登陆

export const SET_MEMBER = 'setMember'; //存用户信息
export const GET_MEMBER = 'getMember'; //获取用户
export const GET_MEMBER_ISLOGIN = 'isLogin'; //判断是否登录

export const ACTION_KEEP_SESSION = 'keepSession'; //获取用户
export const ACTION_LOGOUT = 'logout'; //获取用户

/********************************* cart *************************************/
export const GET_TOTAL_AMOUNT = 'getTotalAmount'; // 获取购物车列表商品总数



// WEBPACK FOOTER //
// ./src/components/work/login/common/interfaces.js